import React, { ReactNode, useRef, useState } from "react"
import Image from "next/image"

import { useElementClientSize } from "@lib"

const DropdownMenu: React.FunctionComponent<{
    title: ReactNode
    className?: string
    anchor?: "START" | "AUTO"
}> = ({
    title,
    className,
    anchor,
    children
}) => {
    const [optionsMenuIsVisible, setOptionsMenuVisible] = useState<boolean>(false)

    const menuContainerRef = useRef(null)
    const [menuContainerWidth] = useElementClientSize(menuContainerRef)

    const titleButtonRef = useRef<HTMLButtonElement>(null)
    const [titleButtonWidth] = useElementClientSize(titleButtonRef)

    return (
        <div className={className}>
            <div className="relative"
                style={{ width: `${Math.max(menuContainerWidth, titleButtonWidth)}px` }}>
                <div>
                    <button type="button" ref={titleButtonRef}
                        className={[
                            "flex",
                            anchor === "START" ? "" : "mx-auto",
                            "px-[12px] py-[4px] items-center bg-tertiary-900 rounded-[4px] text-caption1 text-white-900"
                        ].join(" ")}
                        onClick={() => setOptionsMenuVisible(!optionsMenuIsVisible)}>
                        <span className="flex-auto">{title}</span>
                        <i className={[optionsMenuIsVisible ? "rotate-180" : "rotate-0", "ml-[12px] fa-solid fa-chevron-down"].join(" ")}></i>
                    </button>
                </div>

                <div ref={menuContainerRef}
                    className={[
                        "absolute z-30 inline-flex flex-col mt-[4px] bg-white-900 border-[1px] border-black-500 rounded-[8px] shadow-lg",
                        "min-w-[200px]",
                        optionsMenuIsVisible ? "scale-y-100" : "scale-y-0",
                        "transition-all transform origin-top duration-100 ease-in-out"
                    ].join(" ")}
                    style={{
                        left: anchor === "START" ? 0 : undefined,
                        right: anchor === "START"
                            ? undefined
                            : `${(Math.max(menuContainerWidth, titleButtonWidth) - titleButtonWidth) / 2}px`
                    }}>
                    {React.Children.toArray(children).map((child, index) => {
                        return (
                            <div key={index} className="px-[16x] py-[12px] hover:bg-primary-100">
                                {child}
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default DropdownMenu
